/* RF1 2026-10-03: product page helpers for Rubber Feet Warehouse.
   - $20.00-per-item minimum: suggests (and on first load pre-fills) the smallest quantity whose line total,
     after the Bulk Discounts tier for that quantity, reaches $20.00 (the rule main-cart.liquid enforces).
   - Next-tier nudge from the Bulk Tier Pricing app's own tier data ([data-qb-data]).
   - Sticky add-to-cart label shows the quantity and line total.
   - "Frequently bought together": ticks, combined total, one "Add selected" (POST /cart/add.js, existing variants only; FBT 2026-10-04).
   RF4 2026-10-03: bulk/B2B path. The quote link carries the product, variant, SKU and quantity; at the top tier
   (5,000+ in the app data) a line under the quantity offers a quote for that exact quantity. Nothing is sent from
   here: the link only pre-fills the existing quote form (T7), which the buyer submits. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('rfw-pdp-data');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var MIN = cfg.minimum || 2000;
  var form = document.getElementById(cfg.formId);
  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency || 'USD' }); }
  catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
  var money = function (cents) { return fmt.format(cents / 100); };

  function tiers() {
    var el = document.querySelector('[data-qb-data]');
    if (el) {
      try {
        var d = JSON.parse(el.textContent);
        if (d && d.tiers && d.tiers.length) return d.tiers.slice().sort(function (a, b) { return a.minQty - b.minQty; });
      } catch (e) { /* fall through */ }
    }
    return cfg.fallbackTiers || [];
  }
  function unitFor(price, qty, t) {
    var tier = null;
    for (var i = 0; i < t.length; i++) if (qty >= t[i].minQty) tier = t[i];
    if (!tier) return price;
    if (tier.type === 'percentage') return price * (1 - tier.value / 100);
    if (tier.type === 'amountOff') return Math.max(0, price - tier.value * 100);
    return price;
  }
  function lineFor(price, qty, t) { return Math.round(unitFor(price, qty, t) * qty); }
  function minQtyFor(price, t) {
    if (!price || price >= MIN) return 1;
    var q = Math.ceil(MIN / price);
    for (var i = 0; i < 2000 && lineFor(price, q, t) < MIN; i++) q++;
    return q;
  }
  function variantId() {
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : String(cfg.variants[0].id);
  }
  function variant() {
    var id = variantId();
    for (var i = 0; i < cfg.variants.length; i++) if (String(cfg.variants[i].id) === id) return cfg.variants[i];
    return cfg.variants[0];
  }
  function qtyInput() { return form ? form.querySelector('input[name="quantity"]') : null; }
  function qty() {
    var i = qtyInput();
    var q = i ? parseInt(i.value, 10) : 1;
    return isNaN(q) || q < 1 ? 1 : q;
  }
  function setQty(q) {
    var i = qtyInput();
    if (!i) return;
    i.value = q;
    i.dispatchEvent(new Event('input', { bubbles: true }));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var help = document.querySelector('[data-rfw-qty-help]');
  var stickyBtn = document.querySelector('[data-rfw-sticky-add]');
  var badge = document.querySelector('[data-rfw-bulk-max]');
  var prefilled = false;

  function render() {
    var v = variant();
    var t = tiers();
    var q = qty();
    var min = minQtyFor(v.price, t);
    var line = lineFor(v.price, q, t);
    var parts = [];
    // v6 2026-10-09: only the minimum-order warning, and only while the line total is under the $20.00 per-item minimum.
    // The "N pcs = $X, meets the minimum", next-tier and top-tier quote lines were removed; the quote links below still follow the quantity.
    if (v.price < MIN && q < min) {
      var more = min - q;
      parts.push('<span class="rfw-qty-help__warn">Add ' + more.toLocaleString('en-US') + ' more to reach the ' + money(MIN).replace(/\.00$/, '') + ' minimum <button type="button" class="link" data-rfw-set-qty="' + min + '">Set ' + min.toLocaleString('en-US') + ' pcs</button></span>');
    }
    var top = 0;
    for (var k = 0; k < t.length; k++) if (t[k].minQty > top) top = t[k].minQty;
    var qurl = quoteUrl(v, q >= (top || 5000) ? q : 0);
    document.querySelectorAll('a[data-rfw-quote]').forEach(function (a) { a.href = qurl; });
    // RF4: only rewrite when the text changes. Rewriting on the blur/change that a click on a link inside the help
    // triggers would detach that link mid-click (the quote link did nothing on desktop).
    var html = parts.join('');
    if (help && help.__rfw !== html) { help.innerHTML = html; help.__rfw = html; }
    if (stickyBtn) stickyBtn.textContent = 'Add ' + q + ' · ' + money(line);
    // RF8: per-piece tier strip under the price + per-piece price in the sticky bar.
    var each = Math.round(unitFor(v.price, q, t));
    // v11 2026-10-09: the main price follows the quantity's tier (tier price, regular price struck through, "each at N+ pcs").
    var pb = document.querySelector('.product-info__price .price');
    if (pb) {
      var pcur = pb.querySelector('.price__default .price__current'), pwas = pb.querySelector('.price__default .price__was');
      var cmp = v.compare || 0, tierOn = !isCase(v) && each < v.price;
      var tmin = 0;
      for (var tk = 0; tk < t.length; tk++) if (q >= t[tk].minQty) tmin = t[tk].minQty;
      var note = pb.querySelector('.rfw-price-note');
      if (!note) { note = document.createElement('span'); note.className = 'rfw-price-note'; note.style.cssText = 'display:block;font-size:13px;color:#146c2e;font-weight:600;margin-top:2px'; pb.appendChild(note); }
      if (pcur) pcur.textContent = money(tierOn ? each : v.price);
      var wasCents = cmp > v.price ? cmp : (tierOn ? v.price : 0);
      if (pwas) pwas.textContent = wasCents ? money(wasCents) : '';
      pb.classList.toggle('price--on-sale', !!wasCents);
      var nt = tierOn ? 'each at ' + tmin.toLocaleString('en-US') + '+ pcs' : '';
      if (note.textContent !== nt) note.textContent = nt;
      note.hidden = !nt;
    }
    var se = document.querySelector('[data-rfw-sticky-each]');
    if (se) se.textContent = money(each) + ' each';
    var list = document.querySelector('[data-rfw-tiers-list]');
    if (list) {
      var pt = t.filter(function (x) { return x.type === 'percentage'; });
      var items = list.querySelectorAll('li');
      // Only re-label when the app's tiers line up with the server-rendered cells (same count and minimums).
      var same = pt.length === items.length && pt.every(function (x, i) { return String(x.minQty) === items[i].dataset.min; });
      var cur = 0;
      for (var n = 0; n < items.length; n++) if (q >= parseInt(items[n].dataset.min, 10)) cur = n;
      for (var n2 = 0; n2 < items.length; n2++) {
        var li = items[n2];
        if (same) {
          var pe = li.querySelector('.rfw-tiers__p');
          var txt = money(Math.round(unitFor(v.price, parseInt(li.dataset.min, 10), t)));
          if (pe && pe.textContent !== txt) pe.textContent = txt;
        }
        li.classList.toggle('is-on', n2 === cur);
        if (n2 === cur) li.setAttribute('aria-current', 'true'); else li.removeAttribute('aria-current');
      }
    }
    if (badge) {
      var max = 0;
      for (var j = 0; j < t.length; j++) if (t[j].type === 'percentage' && t[j].value > max) max = t[j].value;
      if (max >= 1) badge.textContent = 'save up to ' + Math.round(max) + '%';
    }
    // FBT 2026-10-04: quantities follow the same tiers; the combined total follows the page quantity and the ticks.
    fbtRender(v, t, q);
  }

  function quoteUrl(v, q) {
    var part = (cfg.product || '') + (v.title && v.title !== 'Default Title' ? ' / ' + v.title : '') + (v.sku ? ' (SKU ' + v.sku + ')' : '') + (cfg.url ? ' ' + cfg.url + '?variant=' + v.id : '');
    var u = (cfg.quoteUrl || '/pages/quote-form') + '?part=' + encodeURIComponent(part.trim());
    if (q) u += '&qty=' + q;
    return u + '#quote';
  }

  function isCase(v) { return /^Case of /i.test(String(v.title || '')); }
  function prefill() {
    var v = variant();
    // v8 2026-10-09: a case pack is one unit of N pieces. Selecting a case resets the quantity to 1 case
    // (the singles' $20 pre-fill must not carry over and add e.g. 34 cases).
    if (isCase(v)) { if (qty() !== 1) setQty(1); prefilled = false; return; }
    var min = minQtyFor(v.price, tiers());
    if (min > 1 && qty() < min) { prefilled = true; setQty(min); }
  }

  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-rfw-set-qty]');
    if (s) { e.preventDefault(); setQty(parseInt(s.dataset.rfwSetQty, 10)); render(); return; }
    // v9 2026-10-09: tapping a "Price per piece by quantity" chip sets the quantity to that tier (never below the $20 minimum).
    var chip = e.target.closest('[data-rfw-tiers-list] li[data-min]');
    if (chip) { var cm = parseInt(chip.dataset.min, 10) || 1; setQty(Math.max(cm, minQtyFor(variant().price, tiers()))); render(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var chip = e.target.closest && e.target.closest('[data-rfw-tiers-list] li[data-min]');
    if (chip) { e.preventDefault(); chip.click(); }
  });
  document.querySelectorAll('[data-rfw-tiers-list] li[data-min]').forEach(function (li) {
    li.setAttribute('role', 'button'); li.tabIndex = 0; li.style.cursor = 'pointer';
    li.setAttribute('aria-label', 'Set quantity to ' + (li.dataset.min === '1' ? 'the minimum' : parseInt(li.dataset.min, 10).toLocaleString('en-US') + ' pieces'));
  });
  if (form) {
    form.addEventListener('input', function () { render(); });
    form.addEventListener('change', function () { render(); });
  }
  // Variant changes swap the hidden id input; re-check the minimum when that happens.
  var lastVariant = variantId();
  document.addEventListener('on:variant:change', function () {
    setTimeout(function () {
      if (variantId() !== lastVariant) { lastVariant = variantId(); prefill(); }
      render();
    }, 0);
  });

  // ---- Frequently bought together (FBT 2026-10-04) ----
  // Every ticked line (this item at the page quantity, each pick at the smallest quantity that meets the $20.00 minimum
  // after its Bulk Discounts tier) is added with one POST /cart/add.js. Prices come from the server-rendered variant
  // prices; nothing is discounted or changed here.
  var fbt = document.querySelector('[data-rfw-fbt]');
  function status(msg) { var s = fbt && fbt.querySelector('[data-fbt-status]'); if (s) s.innerHTML = msg; }
  function fbtLines(v, t, q) {
    var out = [];
    if (!fbt) return out;
    var me = fbt.querySelector('[data-fbt-this]');
    if (me) {
      me.dataset.price = v.price;
      var mq = Math.max(q, minQtyFor(v.price, t)); // never add a line the cart's $20.00 rule would block
      out.push({ el: me, id: parseInt(v.id, 10), qty: mq, price: v.price, line: lineFor(v.price, mq, t), on: me.checked && !me.disabled });
    }
    fbt.querySelectorAll('[data-fbt-pick]').forEach(function (cb) {
      var price = parseInt(cb.dataset.price, 10) || 0;
      var m = minQtyFor(price, t);
      cb.dataset.qty = m;
      out.push({ el: cb, id: parseInt(cb.dataset.variantId, 10), qty: m, price: price, line: lineFor(price, m, t), on: cb.checked });
    });
    return out;
  }
  function fbtRender(v, t, q) {
    if (!fbt) return;
    var lines = fbtLines(v, t, q);
    var n = 0, total = 0;
    lines.forEach(function (l) {
      var li = l.el.closest('.rfw-fbt__item');
      var txt = li && li.querySelector('[data-fbt-line]');
      var label = (l.qty > 1 ? l.qty + ' × ' + money(Math.round(unitFor(l.price, l.qty, t))) + ' = ' : '') + money(l.line);
      if (txt && txt.textContent !== label) txt.textContent = label;
      if (li) li.classList.toggle('is-off', !l.on);
      if (l.on) { n++; total += l.line; }
    });
    var tot = fbt.querySelector('[data-fbt-total]');
    if (tot) { tot.textContent = money(total); tot.dataset.cents = total; }
    var all = fbt.querySelector('[data-fbt-all]');
    if (all && !all.dataset.busy) {
      all.disabled = !n;
      all.textContent = n ? 'Add ' + n + ' item' + (n > 1 ? 's' : '') + ' to cart' : 'Select an item';
    }
  }
  function add(items, btn, then) {
    if (btn) { btn.disabled = true; btn.dataset.busy = '1'; btn.textContent = 'Adding…'; }
    var done = function () { if (btn) { delete btn.dataset.busy; btn.disabled = false; } render(); };
    return fetch((window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        done();
        if (!res.ok) { status(res.d.description || res.d.message || 'Could not add to cart.'); return; }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.d.sections && res.d.sections['cart-icon-bubble']) bubble.innerHTML = res.d.sections['cart-icon-bubble'];
        if (then) then(res.d);
      })
      .catch(function () { done(); status('Could not add to cart. Please try again.'); });
  }
  if (fbt) {
    fbt.addEventListener('click', function (e) {
      var all = e.target.closest('[data-fbt-all]');
      if (!all) return;
      var items = fbtLines(variant(), tiers(), qty()).filter(function (l) { return l.on && l.id; })
        .map(function (l) { return { id: l.id, quantity: l.qty }; });
      if (!items.length) return;
      add(items, all, function () {
        if (window.gtag) gtag('event', 'add_to_cart', { source: 'frequently_bought_together', items: items.length });
        if (window.rfwTrack) rfwTrack('fbt_add', { mode: 'selected', items: items.length, modes: fbt.dataset.modes || '' });
        location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
      });
    });
    fbt.addEventListener('change', function () { render(); });
  }

  function start() { prefill(); render(); }
  // The Bulk Tier Pricing widget script is deferred too; run after the document has parsed.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
